import React from 'react';
import { Link } from 'react-router-dom';
import { Trash2, Settings, LogIn, Type } from 'lucide-react';

const AccountDeletionPage: React.FC = () => {
  return (
    <div className="legal-page">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
            </div>
            <div className="flex items-center space-x-2">
              <div className="flex items-center gap-2">
                <a 
                  href="https://smarteco.ai/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                >
                  <img src={`${process.env.PUBLIC_URL}/SVGIcons/SmartecoLogo.svg`} alt="Logo" className="smarteco-logo h-10 w-auto"/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm border p-8">
          <div className="prose prose-gray max-w-none">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">SmartEco Account Deletion</h1>
            </div>

            <section className="mb-8">
              <p className="text-gray-700 mb-6 text-lg">
                Users can delete their SmartEco account directly from the application.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">How to Delete Your Account</h2>
              <p className="text-gray-700 mb-4">Follow these steps to delete your SmartEco account:</p>
              <ol className="list-decimal pl-6 text-gray-700 mb-4 space-y-3">
                <li className="flex items-start">
                  <LogIn className="h-5 w-5 mr-2 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Log in to the SmartEco app.</span>
                </li>
                <li className="flex items-start">
                  <Settings className="h-5 w-5 mr-2 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Go to Account Settings.</span>
                </li>
                <li className="flex items-start">
                  <Trash2 className="h-5 w-5 mr-2 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Select &quot;Delete Account&quot;.</span>
                </li>
                <li className="flex items-start">
                  <Type className="h-5 w-5 mr-2 text-green-600 mt-0.5 flex-shrink-0" />
                  <span>Type DELETE to confirm.</span>
                </li>
              </ol>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">What Gets Deleted</h2>
              <p className="text-gray-700 mb-4">
                Deleting your account permanently removes:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
                <li>Profile and personal information</li>
                <li>Connected devices</li>
                <li>User preferences</li>
                <li>Historical air quality data</li>
              </ul>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-4">
                <p className="text-gray-700">
                  <strong>Warning:</strong> This action cannot be undone. Once you delete your account, all your data will be permanently removed and cannot be recovered.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Need Assistance?</h2>
              <p className="text-gray-700 mb-4">
                For assistance contact:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  <strong>Email:</strong> <a href="mailto:smartecosupport@ispatialtec.com" className="text-primary-600 hover:text-primary-500 underline">smartecosupport@ispatialtec.com</a>
                </p>
              </div>
            </section>

            <div className="border-t pt-8 mt-8">
              <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
                <Link
                  to="/privacy"
                  className="text-primary-600 hover:text-primary-500 underline"
                >
                  View Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  className="text-primary-600 hover:text-primary-500 underline"
                >
                  View Terms of Service
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletionPage;
